// extracted by mini-css-extract-plugin
export var chevron = "_jn-4";
export var chevronExpanded = "_jn-5";
export var row = "_jn-0";
export var rowBody = "_jn-6";
export var rowDescription = "_jn-7";
export var rowHeader = "_jn-1";
export var rowTitle = "_jn-2";
export var rowTitleComplete = "_jn-3";